<template>

  <BonusBasilicata />

</template>

<script>
import BonusBasilicata from '../components/ask/pages/BonusBasilicata.vue'

export default {
  components: {
    BonusBasilicata

  },
  data() {
    return {

    }
  },

  created(){
    
  },

  mounted(){
    this.$eventBus.emit('page-change', {
      target: this,
      currentRoute: this.$router.currentRoute.value
    })
  },

  methods: {
    
  },
}
</script>

